module.exports = __webpack_public_path__ + "ed0d1ca9bff689a269140140f357f05e.fbx";